import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-catalog",
  "use": "icon-catalog-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-catalog\"><path d=\"M19.5 1.5H6A1.5 1.5 0 0 0 4.5 3v3H3v1.5h1.5v3.75H3v1.5h1.5v3.75H3V18h1.5v3A1.5 1.5 0 0 0 6 22.5h13.5A1.5 1.5 0 0 0 21 21V3a1.5 1.5 0 0 0-1.5-1.5Zm0 19.5H6v-3h1.5v-1.5H6v-3.75h1.5v-1.5H6V7.5h1.5V6H6V3h13.5v18Z\" /><path d=\"M10.5 6h6v1.5h-6V6Zm0 5.25h6v1.5h-6v-1.5Zm0 5.25h6V18h-6v-1.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol